import { SparklesIcon } from 'lucide-react'
import React from 'react'
import { useRedirect } from '../../Shared/Hooks/useRedirect '

function RecruiterDashboardHeader() {
    const redirect = useRedirect();
     const editProfileHandleClick = () => {
    redirect("/recruiter/profile");
  };
  return (
    <div>
        <header className="relative mb-10 flex flex-col md:flex-row md:items-center justify-between gap-6 overflow-hidden bg-gradient-to-r from-indigo-900 via-violet-900 to-fuchsia-900 p-6 md:p-8 rounded-2xl border border-white/10 shadow-2xl shadow-indigo-950/40 mt-7">
  <div className="pointer-events-none absolute -top-20 -right-16 h-64 w-64 rounded-full bg-fuchsia-500/25 blur-3xl" />
  <div className="pointer-events-none absolute -bottom-24 -left-10 h-64 w-64 rounded-full bg-cyan-400/20 blur-3xl" />
  <div className="relative text-white">
    <div className="flex items-center gap-3 mb-2">
      <SparklesIcon className="h-7 w-7 text-yellow-400 animate-pulse" />
      <h1 className="text-4xl md:text-5xl font-extrabold uppercase tracking-tight bg-gradient-to-r from-yellow-200 via-pink-400 to-purple-400 bg-clip-text text-transparent">
        Next Generation Talent
      </h1>
    </div>
    <p className="text-indigo-100/90 font-medium text-lg md:pl-1">
    Top Leaders Don't Apply. You Discover Them First.
    </p>
  </div>
  
  <button 
    onClick={editProfileHandleClick} 
    className="relative group overflow-hidden bg-white text-indigo-950 hover:text-white px-6 py-3.5 rounded-xl font-bold shadow-xl transition-all duration-300 active:scale-95 flex items-center justify-center gap-2 self-start md:self-center"
  >
    {/* Hover gradient background effect */}
    <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-pink-500 via-purple-600 to-indigo-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-0"></span>
    
    <span className="relative z-10 flex items-center gap-2">
      <span  className="text-xl font-light group-hover:scale-110 transition-transform">+</span> Set Profile
    </span>
  </button>
</header>
    </div>

  )
}

export default RecruiterDashboardHeader